/** The layout grid has this many columns; a plot spans 1..GRID_COLUMNS of them. */
export const GRID_COLUMNS = 12;

/**
 * What the guided builder chose, kept beside the query so a plot can be reopened
 * and a stream added, rather than the query text having to be edited by hand.
 * Absent on a hand-written plot, which is why every field here is optional at the
 * boundary and validated on load.
 */
export interface BuilderState {
    mode: 'stream' | 'event';
    streamIds: string[];
    /** The window by label: the preset lists are rebuilt per resolution. */
    presetLabel: string | null;
    threshold: { value: number; direction: 'above' | 'below' } | null;
    eventTypeId: string | null;
    eventCount: number;
    forecastView: string | null;
    criticalYears: number | null;
    linkEvents: boolean;
}

export interface Plot {
    id: string;
    name: string;
    query: string;
    /** Present when the guided builder made this plot; see `BuilderState`. */
    builder?: BuilderState;
    /** Width as a span of the layout grid, 1..GRID_COLUMNS. */
    cols: number;
    /** Height in pixels; width follows the grid so the page can reflow. */
    height: number;
    notes: string;
}

export function clampCols(value: unknown, fallback: number): number {
    const parsed = Math.round(Number(value));
    return Number.isFinite(parsed) ? Math.min(GRID_COLUMNS, Math.max(1, parsed)) : fallback;
}

export type PlotDraft = Omit<Plot, 'id'>;

/** A named page of plots within one project. */
export interface PlotTab {
    id: string;
    name: string;
    plots: Plot[];
}

export function emptyDraft(): PlotDraft {
    return {
        name: '',
        query: '',
        cols: 6,
        height: 420,
        notes: '',
    };
}
